<template>
  <div class="addtask">
    <h2 v-if="!this.id">新增试卷</h2>
    <h2 v-else>编辑试卷</h2>
    <el-main class="addtaskcom">
      <h4>基本信息</h4>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="addtaskForm"
      >
        <el-form-item label="试卷名称:" prop="title">
          <el-input v-model="ruleForm.title" class="ruleInput"></el-input>
        </el-form-item>
        <el-form-item prop="type" label="选择类型:">
          <el-select v-model="ruleForm.type" @change="upClassify">
            <el-option
              v-for="item in types"
              :key="item.type"
              :label="item.name"
              :value="item.type"
            ></el-option>
          </el-select>
          <!--
                <el-button type="text" @click="addtcview = true" ><i class="el-icon-plus"></i>新增分类</el-button> -->
        </el-form-item>
        <el-form-item prop="view" label="选择分类:">
          <el-select
            v-model="ruleForm.view"
            :disabled="ruleForm.type === ''"
            :placeholder="ruleForm.type === '' ? '请先选择类型' : '请选择'"
          >
            <el-option
              :value="ruleForm.view"
              style="height: 0"
              id="viewOp"
            ></el-option>
            <el-tree
              :data="data"
              :props="defaultProps"
              @node-click="ViewClick"
              ref="tree"
              node-key="id"
            ></el-tree>
          </el-select>
          <el-button type="text" @click="addtcview = true"
          ><i class="el-icon-plus"></i>新增分类
          </el-button
          >
        </el-form-item>

        <el-form-item label="试卷说明:" prop="explain">
          <el-input
            type="textarea"
            :rows="6"
            resize="none"
            placeholder="请输入试卷说明"
            class="textareaInput"
            v-model="ruleForm.explain"
          >
          </el-input>
        </el-form-item>
        <div class="borderInput"></div>
        <div class="buttonInput">
          <h5>添加试题</h5>
          <el-button @click="addView"
          ><i class="el-icon-plus"></i>选择试题
          </el-button
          >
        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          class="exam_table"
        >
          <el-table-column label="序号" width="68" type="index">
          </el-table-column>
          <el-table-column
            v-for="info in tableHeadr"
            :key="info.key"
            :property="info.key"
            :label="info.label"
            :width="info.width"
          >
            <template slot-scope="scope">
              {{ scope.row[scope.column.property] }}
              <!-- 渲染对应表格里面的内容 -->
            </template>
          </el-table-column>
          <el-table-column label="题型" width="65">
            <template slot-scope="scope">
              <span>{{
                  scope.row.q_type == 1
                    ? "单选"
                    : scope.row.q_type == 2
                      ? "判断"
                      : scope.row.q_type == 3
                        ? "填空"
                        : scope.row.q_type == 4
                          ? "简答"
                          : "多选"
                }}</span>
            </template>
          </el-table-column>
          <el-table-column label="分值" width="65">
            <template slot-scope="scope">
              <span class="examScroe">{{ scope.row.scores }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="分值设置"
            width="209"
            class="numberInput"
            prop="number"
          >
            <template slot-scope="scope" style="text-align: left; width: 122px">
              <el-input
                type="number"
                class="tableNum"
                @input="changetxt(scope, scope.$index)"
                v-model="scope.row.score"
                style="float: left"
                :min="0"
                :max="100"
              ></el-input>
              <span
                style="
                  float: left;
                  margin-top: 7px;
                  margin-left: 14px;
                  font-size: 16px;
                "
                v-if="scope.row.q_type == 3 || scope.row.q_type == 4"
                class="tableX"
              ><b
                style="
                    font-weight: normal;
                    margin-top: 4px;
                    margin-right: 5px;
                    display: inline-block;
                  "
              >*</b
              ><i style="font-style: normal">{{ scope.row.num }}</i
              >{{ scope.row.q_type == 3 ? "空" : "词" }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <i
                class="el-icon-delete-solid"
                size="small"
                style="font-size: 20px; cursor: pointer"
                @click="handleDelete(scope)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
        <h5>总分与及格线</h5>
        <div class="clear"></div>
        <el-form-item label="及格线:" prop="pogenum" label-width="auto">
          <el-input-number
            v-model="ruleForm.pogenum"
            controls-position="right"
            :min="1"
            :max="100"
          ></el-input-number>
          <span>%</span>
        </el-form-item>
        <div class="paperScore">
          <p>
            总分：<b>{{ paperF }}</b>
          </p>
        </div>

        <div class="buttonInput">
          <h5>添加经验课</h5>
          <el-button @click="selectJykDialog"
          ><i class="el-icon-plus"></i>选择经验课
          </el-button>
        </div>
        <div v-if="check_jyk.id">
          <div class="demo-image__placeholder"
               style="display: inline-block; width: 300px;margin-left: 0;max-height: 400px">
            <div class="block">
              <el-link  :href="check_jyk.video" target="_blank">
                <el-image :src="check_jyk.picture">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline">无封面</i>
                  </div>
                </el-image>
                <br/>
                <span class="demonstration" style="font-size: 18px;overflow: hidden">{{ check_jyk.title }}</span>
              </el-link>
            </div>
          </div>
          <div style="display: inline-block;margin-left: 20px">
            <el-button type="danger" icon="el-icon-delete" circle @click="check_jyk=[]"></el-button>
          </div>
        </div>
        <div class="buttonInput">
          <h5>添加必修课</h5>
          <el-button @click="selectBxkDialog"
          ><i class="el-icon-plus"></i>选择必修课
          </el-button>
        </div>
        <div v-if="check_bxk.id">
          <div class="demo-image__placeholder"
               style="display: inline-block; width: 300px;margin-left: 0;max-height: 400px">
            <div class="block">
              <el-link  :href="check_bxk.aliyunurl" target="_blank">
                <video :src="check_bxk.aliyunurl" style="width: 300px"></video>
                <br/>
                <span class="demonstration" style="font-size: 18px;overflow: hidden">{{ check_bxk.file_path }}</span>
              </el-link>
            </div>
          </div>
          <div style="display: inline-block;margin-left: 20px">
            <el-button type="danger" icon="el-icon-delete" circle @click="check_bxk=[]"></el-button>
          </div>
        </div>

        <div class="addstaskUp">
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            v-if="!this.id"
          >保存
          </el-button
          >
          <el-button type="primary" @click="editForm('ruleForm')" v-else
          >修改
          </el-button
          >
          <el-button @click="hrefTo">返回</el-button>
        </div>
      </el-form>
    </el-main>
    <el-dialog
      title="新增分类"
      :visible.sync="addtcview"
      custom-class="dialogAddtime"
    >
      <div class="addnewName">
        <b>*</b><span>分类名称：</span>
        <el-input v-model="newView"></el-input>
      </div>

      <!-- <el-select v-model="type" clearable placeholder="请选择">
        <el-option
          v-for="item in typeClass"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select> -->

      <div class="addnewName">
        <b>*</b><span>上级分类：</span
      >
        <el-input v-model="prevView" disabled></el-input>
      </div>
      <div class="ViewWrap">
        <el-tree
          :data="data"
          :props="defaultProps"
          @node-click="nodeclick"
        ></el-tree>
      </div>
      <div slot="footer" class="dialogtimefoot">
        <el-button type="primary" @click="upchilView">确定</el-button>
        <el-button @click="addtcview = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="选择经验课"
      :visible.sync="openJykDialog"
      custom-class="dialogFw dialogSt"
    >
      <div class="ViewDialog_search">
        <el-input
          placeholder="请输入内容"
          v-model="jykSearch"
          class="searchFw"
          @change="searchJyk"
        ><i slot="prefix" class="el-input__icon el-icon-search"></i
        ></el-input>
      </div>

      <div>
        <div class="jyk-css">
          <template>
            <el-table
              :data="course_list"
              stripe
              style="width: 100%">
              <el-table-column
                prop="title"
                align="center"
                label="标题">
              </el-table-column>
              <el-table-column
                prop="video"
                align="center"
                label="视频">
                <template slot-scope="scope">
                  <div v-if="scope.row.video">
                    <el-link target="_blank" :href="scope.row.video" type="primary">视频链接</el-link>
                  </div>
                  <div v-else>
                    <el-link type="danger">无</el-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <div class="jyk-radio-cz">
                    <el-radio v-model="check_jyk" :label="scope.row"></el-radio>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template>
            <div class="block jyk-fy" style="margin-top: 20px">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="Number(page)"
                :page-size="Number(page_size)"
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[5,10, 20, 30, 40, 50]"
                :total="Number(count)">
              </el-pagination>
            </div>
          </template>
        </div>

        <div class="ViewDiaolog_Btn">
          <el-button type="primary" @click="select_data()">保存</el-button>
          <el-button @click="closeJykDialog()">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="选择必修课"
      :visible.sync="openBxkDialog"
      custom-class="dialogFw dialogSt"
    >
      <div class="ViewDialog_search">
        <el-input
          placeholder="请输入内容"
          v-model="bxkSearch"
          class="searchFw"
          @change="searchBxk"
        ><i slot="prefix" class="el-input__icon el-icon-search"></i
        ></el-input>
      </div>

      <div>
        <div class="jyk-css">
          <template>
            <el-table
              :data="course_list_bxk"
              stripe
              style="width: 100%">
              <el-table-column
                prop="file_path"
                align="center"
                label="标题">
              </el-table-column>
              <el-table-column
                prop="video"
                align="center"
                label="视频">
                <template slot-scope="scope">
                  <div v-if="scope.row.aliyunurl">
                    <el-link target="_blank" :href="scope.row.aliyunurl" type="primary">视频链接</el-link>
                  </div>
                  <div v-else>
                    <el-link type="danger">无</el-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <div class="jyk-radio-cz">
                    <el-radio v-model="check_bxk" :label="scope.row"></el-radio>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template>
            <div class="block jyk-fy" style="margin-top: 20px">
              <el-pagination
                background
                @size-change="handleSizeChangeBxk"
                @current-change="handleCurrentChangeBxk"
                :current-page="Number(page_bxk)"
                :page-size="Number(page_size_bxk)"
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[5,10, 20, 30, 40, 50]"
                :total="Number(count_bxk)">
              </el-pagination>
            </div>
          </template>
        </div>

        <div class="ViewDiaolog_Btn">
          <el-button type="primary" @click="select_data_bxk()">保存</el-button>
          <el-button @click="closeBxkDialog()">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <dialogFw
      :addViewPaper.sync="addViewPaper"
      :tableData.sync="tableData"
      @addView="addViewTxt"
    ></dialogFw>
  </div>

</template>
<script>
import dialogFw from "../Common/dialog";

export default {
  name: "addpaper",
  data() {
    return {
      count: 0,
      page: 1,
      page_size: 5,
      count_bxk: 0,
      page_bxk: 1,
      page_size_bxk: 5,
      jykSearch: '',
      bxkSearch: '',
      check_jyk: [],
      check_bxk: [],
      course_list: [],
      course_list_bxk: [],
      openJykDialog: false,
      openBxkDialog: false,
      addtcview: false,
      show: false,
      newView: "",
      prevView: "",
      upViewId: "",
      id: this.$route.query.id,
      correct_answer: "",
      tableData: [],
      addViewPaper: false,
      paperF: 0,
      defaultProps: {
        children: "son",
        label: "name",
      },
      scores: "",
      data: [],
      types: [
        {
          name: "考试系统试卷",
          type: 1,
        },
        {
          name: "君臣论-经验课试卷",
          type: 2,
        },
      ],
      classType: "",
      ruleForm: {
        title: "",
        view: "",
        c_id: "",
        explain: "",
        type: "",
      },
      rules: {
        title: [{required: true, message: "请输入试卷名称", trigger: "blur"}],
        view: [
          {required: true, message: "请选择试卷分类", trigger: "change"},
        ],
        pogenum: [
          {required: true, message: "请选择及格线", trigger: "change"},
        ],
        type: [
          {required: true, message: "请选择试卷类型", trigger: "change"},
        ],
      },
      tableHeadr: [
        {
          label: "题目",
          key: "questions",
          width: "427",
        },
      ],
    };
  },
  components: {
    dialogFw,
  },
  methods: {

    handleSizeChange(val) {
      this.page_size = val
      this.searchJyk()
    },
    handleSizeChangeBxk(val) {
      this.page_size = val
      this.searchBxk()
    },
    handleCurrentChange(val) {
      this.page = val
      this.searchJyk()
    },handleCurrentChangeBxk(val) {
      this.page = val
      this.searchBxk()
    },
    addViewTxt(list) {
      this.tableData = list;
    },
    addView() {
      this.addViewPaper = true;
    },
    closeJykDialog() {
      this.openJykDialog = false
      this.check_jyk = []

    },
    closeBxkDialog() {
      this.openBxkDialog = false
      this.check_bxk = []

    },
    selectJykDialog() {
      this.openJykDialog = true;
    },
    selectBxkDialog() {
      this.openBxkDialog = true;
    },
    select_data() {
      this.openJykDialog = false
    },select_data_bxk() {
      this.openBxkDialog = false
    },
    nodeclick(node, data, vuecomponent) {
      let reslen = data.childNodes.length;
      if (node.pid == 0) {
        this.prevView = "一级分类不需要选择";
      } else {
        this.prevView = data.label;
      }
      this.upViewId = node.c_id;
    },
    searchJyk() {
      var data = {
        service: "Course.searchJy",
        select_key: this.jykSearch,
        page: this.page,
        page_size: this.page_size,
        userid: localStorage.getItem("userid"),
      };
      this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
        console.log(res)
        if (res.data.ret === 200) {
          this.course_list = res.data.data.list;
          this.count = res.data.data.count;
        } else {
          this.alertView.failView(res.data.data.msg);
        }
      });
    },
    searchBxk() {
      var data = {
        service: "Course.searchBxk",
        select_key: this.bxkSearch,
        page: this.page_bxk,
        page_size: this.page_size_bxk,
        userid: localStorage.getItem("userid"),
      };
      this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
        console.log(res)
        if (res.data.ret === 200) {
          this.course_list_bxk = res.data.data.list;
          this.count_bxk = res.data.data.count;
        } else {
          this.alertView.failView(res.data.data.msg);
        }
      });
    },
    upchilView() {
      var datagroup = [];
      var data = {
        service: "Cate.Catesonadd",
        name: this.newView,
        pid: this.upViewId,
        userid: localStorage.getItem("userid"),
      };
      this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
        if (res.data.data.code == 0) {
          this.alertView.successView(res.data.data.msg);
          this.addtcview = false;
          this.$axios
            .post(
              this.HOME,
              this.$qs.stringify({
                service: "Cate.Cateinfo",
                type: this.classType,
                userid: localStorage.getItem("userid"),
              })
            )
            .then((res) => {
              for (var i = 0; i < res.data.data.length; i++) {
                datagroup.push(res.data.data[i]);
              }
              this.data = datagroup;
            });
        } else {
          this.alertView.failView(res.data.data.msg);
        }
      });
    },
    ViewClick(node, data, vuecomponent) {
      let res = data.childNodes.length;
      if (res == 0) {
        this.ruleForm.c_id = data.data.c_id;
        this.ruleForm.view = data.label;
        $(".el-select").eq(1).trigger("click");
      }
    },
    hrefTo() {
      this.$router.go(-1);
    },
    changetxt(ip, ix) {
      console.log(ix);
      var i = "";
      var s = [];
      var num = 0;
      console.log(ip.row.score);
      if (ip.row.q_type == 3 || ip.row.q_type == 4) {
        ip.row.scores = ip.row.score * ip.row.num;
      } else {
        ip.row.scores = ip.row.score;
      }
      for (let n = 0; n < $(".tableNum").length; n++) {
        if ($(".tableNum").eq(n).find("input").val() == "") {
          var sum = 0;
        } else if ($(".tableNum").eq(n).siblings("span").length > 0) {
          var sum =
            parseInt($(".tableNum").eq(n).find("input").val()) *
            parseInt($(".tableNum").eq(n).siblings().find("i").text());
        } else {
          var sum = parseInt($(".tableNum").eq(n).find("input").val());
        }
        s.push(sum);
      }
      for (let i in s) {
        num += s[i];
      }
      if (num > 100) {
        num = 0;
        var snum = [];
        this.alertView.failView("总分不能超过100分");
        ip.row.scores = "";
        ip.row.score = "";
        $(".tableNum").eq(ix).find("input").val("");
        for (let n = 0; n < $(".tableNum").length; n++) {
          if ($(".tableNum").eq(n).find("input").val() == "") {
            var sum = 0;
          } else if ($(".tableNum").eq(n).siblings("span").length > 0) {
            var sum =
              parseInt($(".tableNum").eq(n).find("input").val()) *
              parseInt($(".tableNum").eq(n).siblings().find("i").text());
          } else {
            var sum = parseInt($(".tableNum").eq(n).find("input").val());
          }
          snum.push(sum);
        }
        for (let i in snum) {
          num += snum[i];
        }
        this.paperF = num;
        return false;
      }
      this.paperF = num;
    },
    // getSummaries(param) {
    // const { columns, data } = param
    // const sums = []
    // columns.forEach((column, index) => {
    // 	if (index === 0) {
    // 		sums[index] = '合计'
    // 	}
    // 	// index >= 3 || index <= 11 是你需要计算的列
    // 	// 当然也可以指定一个或者多个列
    // 	// index === 2 || index === 3 这样值求和第二个与第三个列
    // 	else if (index === 4) {
    //         const values = data.map(item => Number(item.score))
    //             if (!values.every(value => isNaN(value))) {
    //                 sums[index] = values.reduce((prev, curr) => {
    //                     const value = Number(curr)
    //                     if (!isNaN(value)) {
    //                         // 保存了两位小数点
    //                         return Math.floor((prev + curr) * 100) / 100;
    //                     } else {
    //                         // 保存了两位小数点
    //                         return Math.floor(prev * 100) / 100;
    //                     }
    //                     }, 0)
    //                     this.paperF = sums[index]
    //                 } else {
    //                     sums[index] = 'N/A'
    //                 }
    //             } else {
    //                 sums[index] = ''
    //             }
    //         })
    //         return sums},
    submitForm(formName) {
      var list = [];
      for (let n in this.tableData) {
        console.log(this.tableData[n].score);
        if (
          this.tableData[n].score === "" ||
          this.tableData[n].score === undefined
        ) {
          this.alertView.failView("分值设置不能为空");
          return false;
        }
        list.push({
          id: this.tableData[n].q_id,
          score: this.tableData[n].score,
        });
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.paperF != 100) {
            this.alertView.failView("总分必须达到100分");
            return false;
          }
          var data = {
            service: "Exampaper.Paperadd",
            p_desc: this.ruleForm.explain,
            c_id: this.ruleForm.c_id,
            courseware_id: this.check_jyk.id ? this.check_jyk.id : 0,
            job_video_id: this.check_bxk.id ? this.check_bxk.id : 0,
            p_mark: (this.paperF * this.ruleForm.pogenum) / 100,
            p_name: this.ruleForm.title,
            questions: JSON.stringify(list),
            userid: localStorage.getItem("userid"),
            exam_type: this.ruleForm.type,
          };
          this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
            if (res.data.data.code == 0) {
              this.alertView.successView("填写成功");
              this.$router.go(-1);
            } else {
              this.alertView.failView(res.data.data.msg);
            }
          });
        } else {
          this.alertView.failView("还有信息未填写");
        }
      });
    },
    editForm(formName) {
      var list = [];
      for (let n in this.tableData) {
        if (
          this.tableData[n].score === "" ||
          this.tableData[n].score === undefined
        ) {
          this.alertView.failView("分值设置不能为空");
          return false;
        }
        list.push({
          id: this.tableData[n].q_id,
          score: this.tableData[n].score,
        });
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.paperF != 100) {
            this.alertView.failView("总分必须达到100分");
            return false;
          }
          const t = Object.prototype.toString
            .call(this.ruleForm.type)
            .slice(8, -1);
          const exam_type =
            t === "Number"
              ? this.ruleForm.type
              : this.getExam_type(this.ruleForm.type);
          console.log(exam_type);

          var data = {
            service: "Exampaper.Paperupd",
            p_id: this.id,
            p_desc: this.ruleForm.explain,
            c_id: this.ruleForm.c_id,
            p_mark: (this.paperF * this.ruleForm.pogenum) / 100,
            p_name: this.ruleForm.title,
            p_scores: this.paperF,
            questions: JSON.stringify(list),
            userid: localStorage.getItem("userid"),
            exam_type,
            courseware_id: this.check_jyk.id ? this.check_jyk.id : 0,
            job_video_id: this.check_bxk.id ? this.check_bxk.id : 0,
          };
          this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
            if (res.data.data.code == 0) {
              this.alertView.successView("填写成功");
              this.$router.go(-1);
            }
          });
        } else {
          this.alertView.failView("还有信息未填写");
        }
      });
    },
    handleDelete(index) {
      this.tableData.splice(index.$index, 1);
      this.$nextTick(function () {
        const scoreEl = $(".examScroe");
        let sumScore = 0;
        if (scoreEl.length) {
          Array.from(scoreEl, (item) => {
            const el = $(item);
            const val = el.text() || 0;
            sumScore += Number(val);
          });
        }
        this.paperF = sumScore;
      });
    },
    getClassify(type) {
      this.data = [];
      this.ruleForm.view = "";
      this.$axios
        .post(
          this.HOME,
          this.$qs.stringify({
            service: "Cate.Cateinfo",
            type,
            userid: localStorage.getItem("userid"),
          })
        )
        .then((res) => {
          const data = res.data.data;
          this.data = data;
        });
    },
    upClassify(value) {
      this.getClassify(value);
    },
    getExam_type(name) {
      const index = this.types.findIndex((item) => {
        return item.name === name;
      });
      return this.types[index].type;
    },
  },
  mounted() {
    // console.log(this.id);
    var data = [];
    // 编辑试卷
    if (this.id) {
      this.$axios
        .post(
          this.HOME,
          this.$qs.stringify({service: "Exampaper.Paperedit", id: this.id})
        )
        .then((res) => {
          var snum = [];
          var num = 0;
          const dataInfo = res.data.data.info;
          const type = dataInfo.exam_type;
          this.ruleForm.type = this.types.find((item) => {
            return item.type == type;
          }).name;
          this.getClassify(type);

          this.ruleForm.title = res.data.data.info.p_name;
          this.ruleForm.explain = res.data.data.info.p_desc;
          this.tableData = res.data.data.qsn;
          this.ruleForm.view = res.data.data.info.name;
          this.ruleForm.c_id = res.data.data.info.c_id;
          this.ruleForm.pogenum = res.data.data.info.p_pass;
          this.check_jyk = res.data.data.courseware;
          this.check_bxk = res.data.data.job_video;

          for (let n in res.data.data.qsn) {
            num += parseInt(res.data.data.qsn[n].scores);
          }
          this.paperF = num;
        });
    }
    this.$axios
      .post(
        this.HOME,
        this.$qs.stringify({
          service: "Cate.Cateinfo",
          userid: localStorage.getItem("userid"),
        })
      )
      .then((res) => {
        for (var i = 0; i < res.data.data.length; i++) {
          data.push(res.data.data[i]);
        }
        this.data = data;
      });
  },
};
</script>
<style>
@import "../../assets/css/task.css";

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
  width: 122px;
  margin-left: 0;
}

.numberInput {
  text-align: left;
}

.tableNum {
  width: 122px;
}

.ViewWrap {
  overflow: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/task/addpaper.vue